import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Copy, RefreshCw, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

const RemoveDuplicateLinesTool = () => {
  const [input, setInput] = useState('');
  const [caseSensitive, setCaseSensitive] = useState(true);
  const [trimLines, setTrimLines] = useState(true);

  const removeDuplicates = () => {
    if (!input) return { output: '', stats: { original: 0, unique: 0, removed: 0 } };
    
    let lines = input.split('\n');
    const original = lines.length;
    
    if (trimLines) {
      lines = lines.map(l => l.trim());
    }
    
    const seen = new Set();
    const unique = lines.filter(line => {
      const key = caseSensitive ? line : line.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
    
    return {
      output: unique.join('\n'),
      stats: {
        original,
        unique: unique.length,
        removed: original - unique.length
      }
    };
  };

  const { output, stats } = removeDuplicates();

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
    toast.success('Unique lines copied!');
  };

  return (
    <div className="space-y-6" data-testid="remove-duplicates-tool">
      <div className="flex gap-4 flex-wrap">
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={caseSensitive}
            onChange={(e) => setCaseSensitive(e.target.checked)}
            className="rounded"
          />
          <span className="text-sm">Case Sensitive</span>
        </label>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={trimLines}
            onChange={(e) => setTrimLines(e.target.checked)}
            className="rounded"
          />
          <span className="text-sm">Trim Whitespace</span>
        </label>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">
            Input ({stats.original} lines)
          </label>
          <Textarea
            placeholder="Enter text with duplicate lines..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="min-h-[250px] font-mono text-sm bg-muted/50"
          />
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">
            Output ({stats.unique} unique, {stats.removed} removed)
          </label>
          <Textarea
            value={output}
            readOnly
            className="min-h-[250px] font-mono text-sm bg-muted/50"
          />
        </div>
      </div>

      <div className="flex gap-2">
        <Button onClick={copyOutput} disabled={!output}>
          <Copy className="w-4 h-4 mr-2" /> Copy Result
        </Button>
        <Button onClick={() => setInput(output)} variant="outline" disabled={!output}>
          <Trash2 className="w-4 h-4 mr-2" /> Apply to Input
        </Button>
        <Button onClick={() => setInput('')} variant="outline">
          <RefreshCw className="w-4 h-4 mr-2" /> Clear
        </Button>
      </div>
    </div>
  );
};

export default RemoveDuplicateLinesTool;
